// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/6dc9994dddca819efd2b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c22682efb32245b7afcc","124":"daa0eceff6b2998ad888","125":"7554e037b870fe4fc6df"}[chunkId] + ".chunk.js";
};